import axios from "utils/httpClient";
import React, { useEffect, useState, Fragment } from "react";
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
import { authHeader } from '_helpers';

// reactstrap components
import {
    Button,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
    Container,
    Row,
    Col,
    Input,
    Label
} from "reactstrap";

import DefaultFooter from "components/Footers/DefaultFooter.js";

const CCNote = (props) => {
    var moment = require('moment');
    require('moment/locale/th');
    const serviceUnitKey = (props.match.params.serviceUnitKey !== undefined) ? props.match.params.serviceUnitKey : null;
    const startDate = (props.match.params.startDate !== undefined) ? props.match.params.startDate : null;
    const endDate = (props.match.params.endDate !== undefined) ? props.match.params.endDate : null;
    //const json = (props.match.params.json !== undefined) ? props.match.params.json : null;


    const length = 12;
    const [Data, SetData] = useState([]);
    const [ClinicVisitKey, SetClinicVisitKey] = useState("");
    const [state, setState] = useState(0);
    const [ServiceUnitKey, setServiceUnitKey] = useState(0);
    const [StartDate, setStartDate] = useState("");
    const [EndDate, setEndDate] = useState("");
    const [CCNote, setCCNote] = useState([]);
    //const [isJSON, setisJSON] = useState("");
    //const [CCNote, setCCNote] = useState(Array.from({ length }, () => 12));


    const handleInput = (inputEv, index, clinicVisitKey) => {
        const value = inputEv.target.value;
        setCCNote((state) => state.map((val, i) => (i !== index ? val : value)));
        // console.log(index);
        // console.log(CCNote);
        // console.log(clinicVisitKey);

        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            },
            data: {
                "CCNote": value,
            }
        };
        axios('/api/v1/checknote/'+ clinicVisitKey, requestOptions)
        .then(response => response.data)
        .then(
            (result) => {},
            (error) => {
                alert('update error' + error);
            }
        )
    };

    
    const handleList = (data) => {
        data.forEach(function (value) {
            CCNote.push(value.CCNote == null ? "" : value.CCNote)
            console.log(CCNote)
        }); 
    };

    useEffect(() => {

        axios('/api/v1/checknote/' + serviceUnitKey + '/' + startDate + '/' + endDate, {
            method: 'GET',
            headers: authHeader()
        })
        .then(response => response.data)
        .then(
            (result) => {
                SetData(result.data);
                handleList(result.data)
            },
            (error) => {
                //alert(error);
            }
        );
        
        if (serviceUnitKey != null) {
            setServiceUnitKey(serviceUnitKey);
        }    
        if (startDate != null) {
            setStartDate(startDate);
        }    
        if (endDate != null) {
            setEndDate(endDate);
        }    
        // if (json != null) {
        //     setisJSON(json);
        // }    
            
    }, []);

    
    useEffect(() => {

        axios('/api/v1/checknote/' + ServiceUnitKey + '/' + StartDate + '/' + EndDate, {
            method: 'GET',
            headers: authHeader()
        })
            .then(response => response.data)
            .then(
                (result) => {
                    SetData(result.data);
                },
                (error) => {
                    //alert(error);
                }
            );
            
    }, [ServiceUnitKey]);

    function handleClick(row) {
        SetClinicVisitKey(row);
    }

    const handleClick2 = (index) => {
        const updatedState = Data[index];
    
        if (updatedState.other) {
          delete updatedState.other;
          setState((pre) => {

            return pre + 1;
          });
        } else {
          updatedState.other = {
            description: " " //or data from api
          };
          setState((pre) => {
            return pre + 1;
          });
        }
      };

    const currentUser = authenticationService.currentUserValue;
    if (!currentUser) {
        return <Redirect to={{ pathname: '/login-page', /*state: { from: props.location }*/ }} />
    } 
    
    return (
        // <Container>
        //     <Row>
        //         <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{textAlign: 'center'}}>
        //             <h3 className="p-3 text-center">React - Display a list of items</h3>
        //             <table className="table table-striped table-bordered">
        //                 <thead>
        //                     <tr>
        //                         <th>วันที่</th>
        //                     </tr>
        //                 </thead>
        //                 <tbody>
        //                 {Data && Data.map(data =>
        //                     <tr key={data.clinicVisitKey} onClick={() => handleClick(data.clinicVisitKey)}> 
        //                         <td>{data.docDT}</td>
        //                     </tr>
        //                     )}
        //                 </tbody>
        //             </table>
        //         </Col>
        //     </Row>
        // </Container>

        <div className="wrapper">
            <div className="section" style={{ padding: 30 }}>
                <Container>
                    <h3 className="title" style={{
                        fontSize: '1.2em', backgroundColor: '#f2f2f2', 
                        textAlign: 'center'
                    }}>Note</h3>
            
                 </Container>
            </div>

            {/* {Data && Data.map(data =>
            <Container>
            <Row key={data.clinicVisitKey} style={{ fontSize: '0.85em', padding: '10px 10px', borderBottom: '1px solid #dddddd' }}>
                <Col md="12" xs="12">
                    {data.docDT}
                </Col>
            </Row>
            </Container>
             )} */}
          
          {Data && Data.map((row, index) => (
            <Fragment key={`${index}${row.ClinicVisitKey}`}>
            <Container>
            <Row key={row.ClinicVisitKey} style={ row.other ? { fontSize: '0.85em', padding: '10px 10px',
                    cursor: "pointer", textAlign: "center", fontWeight: 'bold', backgroundColor: '#f2f2f2'} 
                    : { fontSize: '0.85em', padding: '10px 10px', borderBottom: '1px solid #dddddd',
                    cursor: "pointer", textAlign: "center", fontWeight: 'bold'}} onClick={() => handleClick2(index)}>
                 <Col md="6" xs="12">
                    {row.Patient} {moment(row.RecordDT).format('DD MMM BB, HH:mm น.')} 
                </Col>
                <Col md="6" xs="12">
                    {row.ServiceUnit}
                </Col>
            </Row>
            </Container>
              {row.other ? (
                <Container>
                <Row style={{fontSize: '0.85em', fontWeight: 'bold', textAlign: "center", paddingTop: "20px"}}>
                    <Col md="4" xs="12">
                        {row.Cid}
                    </Col>
                    <Col md="4" xs="12">
                       
                    </Col>
                    <Col md="4" xs="12">
                        {row.Patient}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', fontWeight: 'bold', textAlign: "center"}}>
                    <Col md="4" xs="12">
                        {row.Gender}
                    </Col>
                    <Col md="4" xs="12">
                        {row.Age}
                    </Col>
                    <Col md="4" xs="12">
                        {row.HN}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "center"}}>
                    <Col md="4" xs="12">
                        วันที่ {moment(row.RecordDT).format('DD MMM BB, HH:mm น.')}
                    </Col>
                    <Col md="4" xs="12">
                        {row.ServiceUnit}
                    </Col>
                    <Col md="4" xs="12">
                        {row.MC}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.VS}
                    </Col>
                </Row>
                 <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col md="6" xs="12">
                        น้ำหนัก {row.Weight}  กก. ส่วนสูง {row.Height}  ซม. รอบเอว {row.WaistLength} ซม. BMI {row.Bmi} {row.BmiText}
                    </Col>
                    <Col md="6" xs="12">
                        
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.PI}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.PE}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.DX}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.Lab}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.Discharge}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.History}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.Appoint}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.NursingCare}
                    </Col>
                </Row>
                <Row>
                    <Col className="ml-auto mr-auto" md="12" xl="12">
                        <div className="textarea-container" style={{ padding: 0}}>
                            <Label for="CCNote">กรอก CCNote
                                <Input
                                    id="CCNote"
                                    cols="100"
                                    name="CCNote"
                                    placeholder="CCNote"
                                    rows="4"
                                    type="textarea"
                                    style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                    // value={CCNote}
                                    // onChange={e => setCCNote(e.target.value)}
                                    value={CCNote[index]}
                                    onChange={(e) => handleInput(e, index, row.ClinicVisitKey)}
                                ></Input>
                            </Label>
                        </div>
                    </Col>

                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", borderBottom: '1px solid #dddddd', paddingTop: "20px"}}>
                    <Col>
                        {row.Med}
                    </Col>
                </Row>         
                </Container>
              ) : null}
            </Fragment>
          ))}
        <DefaultFooter />
        </div>
    );
}

export default CCNote;
